export default __webpack_public_path__ + "static/media/printerScraper.81b10af2.png";